export const XeroIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 210" height="24">
    <g id="layer1" transform="translate(-6.284 -272.093)">
      <g id="g10" transform="matrix(.35278 0 0 -.35278 -39.93 525.638)">
        <g id="g12">
          <g
            id="g14"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            clipPath="url(#clipPath18)"
          >
            <path
              id="path20"
              fill="#1ab4d7"
              d="M424.933 130.843c162.335 0 293.932 131.597 293.932 293.933 0 162.334-131.597 293.932-293.932 293.932S131 587.11 131 424.776c0-162.336 131.598-293.933 293.933-293.933"
            />
            <path
              id="path22"
              fill="#fff"
              d="m271.701 425.625 50.162 50.286a8.982 8.982 0 0 1 2.591 6.319c0 4.96-4.032 8.988-8.992 8.988a8.91 8.91 0 0 1-6.389-2.676c-.005-.01-50.117-50.093-50.117-50.093l-50.341 50.168a8.986 8.986 0 0 1-6.345 2.601c-4.954 0-8.987-4.026-8.987-8.981 0-2.417.965-4.685 2.697-6.394l50.155-50.148-50.129-50.223c-1.762-1.735-2.723-4.008-2.723-6.436 0-4.959 4.033-8.982 8.987-8.982 2.394 0 4.65.929 6.345 2.625l50.263 50.195 50.072-50.012c1.776-1.836 4.067-2.814 6.512-2.814 4.955 0 8.987 4.029 8.987 8.988a8.92 8.92 0 0 1-2.614 6.336z"
            />
            <path
              id="path24"
              fill="#fff"
              d="M569.906 425.64c0-9.006 7.323-16.332 16.34-16.332 8.996 0 16.322 7.326 16.322 16.332 0 9.008-7.326 16.333-16.322 16.333-9.017 0-16.34-7.325-16.34-16.333"
            />
            <path
              id="path26"
              fill="#fff"
              d="M538.93 425.632c0 26.08 21.216 47.3 47.299 47.3 26.07 0 47.291-21.22 47.291-47.3 0-26.074-21.221-47.285-47.291-47.285-26.083 0-47.299 21.211-47.299 47.285m-18.606 0c0-36.334 29.565-65.895 65.905-65.895 36.339 0 65.919 29.561 65.919 65.895 0 36.339-29.58 65.908-65.919 65.908-36.34 0-65.905-29.569-65.905-65.908"
            />
            <path
              id="path28"
              fill="#fff"
              d="m515.646 490.413-2.765.008c-8.301 0-16.307-2.618-22.994-7.771-.881 4.032-4.485 7.066-8.778 7.066a8.887 8.887 0 0 1-8.912-8.91l.03-111c.013-4.942 4.044-8.959 8.988-8.959 4.943 0 8.973 4.017 8.986 8.97l.004 68.251c0 22.748 2.08 31.935 21.566 34.37 1.801.224 3.76.189 3.768.189 5.332.183 9.121 3.847 9.121 8.799 0 4.955-4.045 8.987-9.014 8.987"
            />
            <path
              id="path30"
              fill="#fff"
              d="M343.072 436.482c0 .246.019.502.031.755 5.218 20.627 23.899 35.891 46.147 35.891 22.517 0 41.369-15.639 46.32-36.646zm110.903 1.697c-3.873 18.337-13.912 33.399-29.199 43.072-22.346 14.187-51.854 13.402-73.438-1.947-17.606-12.525-27.769-33.014-27.769-54.12 0-5.292.638-10.634 1.966-15.892 6.648-26.152 29.13-45.949 55.934-49.23 7.954-.963 15.696-.502 23.713 1.574a64.897 64.897 0 0 1 19.697 8.406c6.375 4.098 11.701 9.502 16.859 15.971.104.119.209.224.313.349 3.58 4.44 2.916 10.754-1.018 13.768-3.318 2.543-8.888 3.574-13.271-2.039a60.766 60.766 0 0 0-3.15-4.104c-3.485-3.851-7.809-7.582-12.99-10.476a47.304 47.304 0 0 0-22.093-5.58c-26.142.291-40.131 18.539-45.107 31.564a47.297 47.297 0 0 0-2.006 7.553c-.061.486-.106.955-.124 1.387l93.812.015c12.861.27 19.783 9.348 17.871 19.729"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
